import https from "./https";
import store from "@/store";

const contact = {
  list(customerID, params) {
    const organization = store.state.general.organization;
    return https.get(
      `/admin/organizations/${organization.id}/customers/${customerID}/contacts`,
      { params }
    );
  },
  get(contactID) {
    const organization = store.state.general.organization;
    return https.get(
      `/admin/organizations/${organization.id}/contacts/${contactID}`
    );
  },
  store(customerID, params) {
    const organization = store.state.general.organization;
    return https.post(
      `/admin/organizations/${organization.id}/customers/${customerID}/contacts`,
      params
    );
  },
  update(contactID, params) {
    const organization = store.state.general.organization;
    return https.put(
      `/admin/organizations/${organization.id}/contacts/${contactID}`,
      params
    );
  },
  delete(contactID) {
    const organization = store.state.general.organization;
    return https.delete(
      `/admin/organizations/${organization.id}/contacts/${contactID}`
    );
  },
};

export default contact;
